import { CommonContext } from '@repo-level/core-front';
import { AnalyticsEventName } from 'api/analytics';
import { ReferralProgramContext } from 'contexts/referralProgram';
import { useAnalytics } from 'helpers/analytics';
import { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface FooterMenuItem {
  name: string;
  url: string;
  onClick?: () => void;
  isHidden?: boolean;
}

export const useFooterMenuList = (): FooterMenuItem[] => {
  const { t } = useTranslation();
  const { sendEventToAnalytics } = useAnalytics();
  const { project } = useContext(CommonContext);
  const { data: referralProgramData } = useContext(ReferralProgramContext);

  const mobileAppAnalyticsEvent = useCallback(() => {
    sendEventToAnalytics({
      name: AnalyticsEventName.FOOTER__MOBILE_APP__LINK__CLICK,
    });
  }, [sendEventToAnalytics]);

  const footerMenuList = useMemo(
    () => [
      {
        name: t('glossary:termsAndConditionsShort'),
        url: '/terms-and-conditions',
      },
      {
        name: t('glossary:bonusTermsShort'),
        url: '/bonus-terms-and-conditions',
      },
      {
        name: t('glossary:privacyPolicy'),
        url: '/privacy-policy',
      },
      {
        name: t('glossary:cookiePolicy').toLowerCase(),
        url: '/cookie-policy',
      },
      {
        name: t('glossary:responsibleGaming'),
        url: '/responsible-gaming',
      },
      {
        name: t('glossary:paymentMethods'),
        url: '/payment-methods',
      },
      {
        name: t(`glossary:mobileApp`),
        url: '/mobile-app',
        onClick: mobileAppAnalyticsEvent,
      },
      {
        name: t(`glossary:referralProgram`),
        url: '/referral-program',
        isHidden:
          !project?.availableReferralSystem || !referralProgramData?.enable,
      },
      {
        name: t(`glossary:aboutUs`),
        url: '/about-us',
      },
      {
        name: t(`glossary:faq`),
        url: '/faq',
      },
    ],
    [mobileAppAnalyticsEvent, project, referralProgramData, t]
  );
  return footerMenuList;
};
